import { PAGE_WITH_HP_UI } from "modules/static-pages/static-page-constants";
import { NextRouter } from "next/router";

function isHighTrafficPage(router: NextRouter) {
  const { query } = router;
  const { pathname } = query;
  return (PAGE_WITH_HP_UI.includes(pathname));
}

export default isHighTrafficPage;
